export default {
    accessToken: state => (
        state.accessToken || sessionStorage.getItem('accessToken')
    ),

    refreshToken: state => (
        state.refreshToken || sessionStorage.getItem('refreshToken')
    ),

    error: state => state.error,

    user: state => state.user
};
